<template lang="html">
  <div class="main">
    <div class="cell">
      <img src="../../../assets/images/entrance-logo.png" alt="">
    </div>
    <div class="cell word" v-if="step === 1 && showMain !== 0">
      {{message.Nl131}}
    </div>
    <div class="cell word" style="margin-bottom:100px;text-align:center" v-if="showMain === 0">
      {{message.Pl156}}
    </div>
    <div class="cell create" v-if="step === 1&&showMain === 0">
      <el-button @click="logout" type="primary">{{message.Sl107}}</el-button>
    </div>
    <div v-if="showMain !== 0">
      <div class="cell button" v-if="step === 1">
        <el-input v-model="name" :placeholder="message.Pl120" maxlength="32"></el-input>
      </div>
      <div class="cell button" v-if="step === 1&&zones.length > 1">
        <el-select v-model="zoneId" style="width:100%" :placeholder="message.Fl123">
         <el-option
           v-for="item in zones"
           :key="item.value"
           :label="item.label"
           :value="item.value">
         </el-option>
       </el-select>
      </div>
      <div class="cell create" v-if="step === 1">
        <el-button @click="create" type="primary">{{message.Sl101}}</el-button>
      </div>
      <div class="cell button" style="margin-bottom:10px;font-weight:600" v-if="step === 2">
        {{ name }}
      </div>
      <!-- <div class="cell word" v-if="step === 2" style="margin-bottom: 40px">
        {{message.Nl132}}
      </div>
      <div class="cell button" v-if="step === 2">
        <el-input v-model="email" :placeholder="message.Pl134"></el-input>
      </div>
      <div class="cell invite" v-if="step === 2">
        <el-button @click="invite" style="background-color: #f37e21;margin-right:20px" type="primary">{{message.Fl119}}</el-button>
        <el-button @click="skip" type="primary">{{message.Fl120}}</el-button>
      </div> -->
      <div class="cell enter" v-if="step === 3">
        {{message.Nl133}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    step: function (val) {
      this.time = 2000
      if (val === 3) {
        setInterval(() => {
          this.time = this.time - 1000
          if (this.time <= 0) {
            this.$router.push({ path: '/app/workspace/inbox' })
          }
        }, 1000)
      }
    }
  },
  data () {
    return {
      message: {
        Nl131: this.$lang.ui.notice.l131,
        Nl132: this.$lang.ui.notice.l132,
        Nl133: this.$lang.ui.notice.l133,
        Pl120: this.$lang.ui.prompt.l120,
        Pl134: this.$lang.ui.prompt.l134,
        Pl156: this.$lang.ui.prompt.l156,
        Fl119: this.$lang.ui.form.l119,
        Fl120: this.$lang.ui.form.l120,
        Fl123: this.$lang.ui.form.l123,
        Sl101: this.$lang.ui.system.l101,
        Sl107: this.$lang.ui.system.l107
      },
      step: 1,
      name: '',
      id: '',
      email: '',
      time: 3000,
      showMain: '',
      zones: [],
      zoneId: 'default'
    }
  },
  mounted () {
    this.$api.getUser(response => {
      this.showMain = response.company_role
    })
    this.$api.getZonesId(response => {
      this.zones = []
      for (var i = 0; i < response.length; i++) {
        this.zones.push({
          label: response[i].name,
          value: response[i].id
        })
      }
      this.zoneId = this.zones[0].value
    })
    var data = {
      id: 'none',
      name: '',
      imgUrl: ''
    }
    this.$store.dispatch('addSpace', data)
  },
  methods: {
    create () {
      if (this.name !== '') {
        this.$http.post('/cydex/api/v1/projects', {
          'name': this.name,
          'zone_id': this.zoneId
        })
          .then(response => {
          // this.step = 2
            this.id = response.data.project.id
            this.$message({
              message: this.$lang.ui.prompt.l145,
              type: 'success',
              duration: 3000
            })
            this.$router.push({ path: '/app/workspace/' })
          })
      }
    },
    invite () {
      var emailTest = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
      if (!emailTest.test(this.email)) {
        this.$message({
          message: this.$lang.ui.prompt.l135,
          type: 'warning',
          duration: 3000
        })
        return
      }
      this.$http.post('/cydex/api/v1/invite', {
        'project_id': this.id,
        'user_to': this.email
      })
        .then(response => {
          this.step = 3
        })
    },
    skip () {
      this.$router.push({ path: '/app/workspace/inbox' })
    },
    logout () {
      this.$api.logout()
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  position: absolute;
  width: 420px;
  /* height: 452px; */
  border-radius: 4px;
  left: 50%;
  top: 10%;
  margin-left: -215px;
  /* background-color: #007bc5; */
  box-shadow: 0 0 2px #607d8b;
  padding: 50px;
  /* color: #fff; */
  font-size: 16px;
}
.cell {
  width: 100%;
  text-align: center;
  margin-bottom: 50px;
}
.cell.word {
  text-align: left;
}
.cell.button {
  margin-bottom: 40px;
}
.cell.create .el-button {
  width: 100%;
  background-color: #f37e21;
  border: 0;
}
.cell.invite .el-button{
  width: 150px;
  margin: 0;
  float: left;
}
.cell.enter {
  margin-top: 140px;
  font-size: 18px;
}
</style>
